<template>
    <AppMainDialogForm v-model="dialog" size='300' :tituloTela="tituloTela" :tooltip="tooltip" 
        :canDelete="false" @initComponent="initComponent" @saveRegistro="saveRegistro" 
        @cancel="cancel" >
        <v-layout row justify-center>
            <v-flex class="item" xs11 md11>
                <v-text-field type="number" v-model.number="nrPesoFinal"
                    label="Peso final(kg)" outlined clearable>
                </v-text-field>
            </v-flex>
        </v-layout>
    </AppMainDialogForm>
</template>

<script>
    import { campoObrigatorio, campoSelectObrigatorio, validarData, isAValidFloat, campoMaiorZero, validarDataFutura, campoMaiorOuIgualZero } from '@/filters/rules'

    import AppMainDialogForm from '@/components/layout/AppMainDialogForm.vue'

    import { mask } from 'vue-the-mask'

    export default {
        components: {
            AppMainDialogForm,
        },
        directives: {
            mask,
        },
        data () {
            return {
                tooltip: 'Informar peso final',
                tituloTela: 'Informar peso final',
                nrPesoFinal: ''
            }
        },
        methods: {
            initComponent() {
                this.nrPesoFinal = this.peso != undefined ? this.peso.toFixed(2) : ''
                this.$emit('openDialog')
            },
            saveRegistro() {
                var rec = {
                    nrPesoFinal: this.nrPesoFinal                        
                }
                this.$axios.put('lote-producao/' + this.$route.params.id + '/update-peso-final/', rec)
                    .then(() => {
                        this.$emit('saved')
                        this.$emit('closeDialog')
                    })
                    .catch((error) => {
                        this.$store.commit('setSnack', {type: 'error', msg : error})
                    })
            },
            cancel() {
                this.$emit('closeDialog')
            }
        },
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            peso: {
                type: Number,
                default: 0
            }
        },
        watch: {
            'dialog' (newValue, oldValue) {
                if (newValue && !oldValue)
                {
                    this.initComponent()
                }
            }
        }
    }
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
